const NOTIFICATIONS_API_URL = '/api/v1/notifications';

export default function () {
    return {
        notificationsList: [],
        open: false,
        showBadge: true,
        count: 0,
        async init() {
            await this.fetchNotifications();
            setInterval(async () => await this.fetchNotifications(), 10000);
        },
        async fetchNotifications() {
            try {
                const response = await axios.get(NOTIFICATIONS_API_URL);
                this.notificationsList = response.data;

                const notificationIds = response.data.map(notification => notification.id).join(',');

                const storedChecksum = Cookie.readCookie('notification_ids');

                if (storedChecksum !== notificationIds) {
                    this.badgeCount();
                    Cookie.eraseCookie('notifications_shown');
                    Cookie.createCookie('notification_ids', notificationIds, 1);
                }
            } catch (error) {
            }
        },
        badgeCount() {
            this.showBadge = this.notificationsList.length > 0;
            this.count = this.notificationsList.length || null;
        },
        toggle() {
            if (this.open) {
                return this.close();
            }

            this.$refs.button.focus();
            this.open = true;

            this.showBadge = false;

            Cookie.createCookie('notifications_shown', 'true', 1);
        },
        close(focusAfter) {
            if (!this.open) {
                return
            }
            this.open = false
            focusAfter && focusAfter.focus()
        },
    }
}